import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';
import {
  BodyLinkV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

const tValue = {
  a: function a(chunks: ReactNode) {
    return (
      <BodyLinkV3
        href="mailto:press@ouraring.com"
        color="blue-200"
        className="text-blue-200"
      >
        {chunks}
      </BodyLinkV3>
    );
  },
};

export const NewsroomContactUs = () => {
  const t = useTranslations();
  const isGen4Enabled = useOuraGen4Enabled();

  return (
    <LayoutGrid>
      <GridItem
        colEnd={{ sm: 'main', lg: 19 }}
        colStart={{ sm: 'main', lg: 9 }}
        className="mb-24"
        data-cy="newsroom-contact-us"
      >
        <TypographyV3 variant="h6" weight="normal">
          {t.rich('press_content_heading', tValue)}
        </TypographyV3>
        {isGen4Enabled && (
          <TypographyV3 className="mt-4" variant="h6" weight="normal">
            {t.rich('press_media_assets', {
              link: (chunks) => (
                <BodyLinkV3
                  aria-label="Newsroom Media Assets"
                  href="https://drive.google.com/drive/folders/1kDpHp2pBc4dhiSZPPNJR6OkqHzi4u6AS"
                  target="_blank"
                  color="blue-200"
                >
                  {chunks}
                </BodyLinkV3>
              ),
            })}
          </TypographyV3>
        )}
      </GridItem>
    </LayoutGrid>
  );
};
